import SocialMediaSvgs from "./SocialMediaSvgs"

function NavBar() {

  function menuBar(e) {
    e.currentTarget.classList.toggle('menu-button-active')
    document.querySelector('.menu-bar').classList.toggle('menu-bar-active')
    document.querySelector('.menu').classList.toggle('menu-active')

  }


  return (
    <nav className="d-flex justify-content-between align-items-center">
      <div className="d-flex ustify-center align-items-center ">
        <div className="circles"><span></span><span></span> </div>
        <SocialMediaSvgs padding="ps-4" />
      </div>
      <div
        className="menu-button menu-btn d-flex flex-column align-items-end justify-content-center"
        onClick={menuBar}>
        <span></span>
        <span></span>
        <span></span>
      </div>

    </nav>
  )
}

export default NavBar